<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 2</h1>
          <div class="text-left">
              <p>Scratchie tickets got nothing.  UK lottery as you only need 2 numbers won 10 pounds plus some bonus</p>
          </div>      
          <div class="text-left">
              <p>We went to Scarborough, here is Frank walking along the street.  It was really cold.</p>
              <img alt="Scarborough" class="uitk-image-media" src="/uk/frankstreetscarborough.jpeg" style="width: 17%; height: auto;">                
          </div>     
          <div class="text-left">
              <p>We went to Whitby where Captian Cook has something to do with.  The Captain Cook Museum is here, it was closed for winter.  Got fish and chips, had some fish stolen by a swooping sea gull, not happy.</p>
              <img alt="Whitby" class="uitk-image-media" src="/uk/whitby.jpeg" style="width: 17%; height: auto;">                
          </div>           
          <div class="text-left">
              <p>We are staying at Dundee for the night.</p>
              <img alt="Dundee" class="uitk-image-media" src="/uk/dundee.png" style="width: 17%; height: auto;">                
          </div>                             
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>